import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { SelfDiagnosisModel } from './model';
import { adapter, SelfDiagnosisState } from './state';

export const stateName: string = 'selfDiagnosis';
export const selectEntityState: MemoizedSelector<object, SelfDiagnosisState> = createFeatureSelector<SelfDiagnosisState>(stateName);

export const getError = (state: SelfDiagnosisState): any => state.error;
export const getIsLoading = (state: SelfDiagnosisState): boolean => state.isLoading;
export const getSelected = (state: SelfDiagnosisState): SelfDiagnosisModel => state.selected;

export const errorSelector: MemoizedSelector<object, any> = createSelector(selectEntityState, getError);
export const isLoadingSelector: MemoizedSelector<object, boolean> = createSelector(selectEntityState, getIsLoading);
export const selectedSelector: MemoizedSelector<object, SelfDiagnosisModel> = createSelector(selectEntityState, getSelected);

export const allSelector: (state: object) => SelfDiagnosisModel[] = adapter.getSelectors(selectEntityState).selectAll;

export const byIdSelector = (id: number) =>
  createSelector(allSelector, (entities: SelfDiagnosisModel[]) => {
    return entities ? entities.find(e => e.id == id) : null;
  });
